import { createSlice } from '@reduxjs/toolkit';

const groupData = createSlice({
  name: 'coursesData',
  initialState: {
    loadPosts: false,
    groupInfo: {},
    loadGroupData: false,
    loadGroups: false,
    loadComments: false,
    unreadGroupNotifications: {}
  },
  reducers: {
    updatePosts: (state, action) => {
      state.loadPosts = action.payload
    },
    setGroupInfo: (state, action) => {
        state.groupInfo = action.payload
    },
    hanldeGroupData: (state, action) => {
        state.loadGroupData = action.payload
    },
    hanldeGroups: (state, action) => {
      state.loadGroups = action.payload
    },
    handleLoadComments: (state, action) => {
      state.loadComments = action.payload;
    },
    handleUnreadGroupNotifications: (state, action) => { 
      state.unreadGroupNotifications = action.payload;
    }
  },
});

export const { updatePosts, setGroupInfo, hanldeGroupData, hanldeGroups, handleLoadComments, handleUnreadGroupNotifications } = groupData.actions;

export default groupData.reducer;
